import React from 'react';

const Percentage = ({ pos, neg }) => {

    return (
        <center>
            <p className="mt-30">Percentage of Positive Reviews</p> <br />
            <h1 className="green">  {pos} %</h1>
            <p className="mt-30">Percentage of Negetive Reviews</p> <br />
            <h1 className="red"> {neg} %</h1>
        </center>
    )


}

export default Percentage;